export default "__VITE_ASSET__CSVewmI$__"